import React, { useState, useContext, useEffect } from 'react';
import {
	IconButton,
	Container,
	Button,
	Paper,
	Typography,
	Stack,
	TableContainer,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import Swal from 'sweetalert2';

import { getToken } from '../../../../api/Account';
import { isAccess, simpleMessage } from '../../../../helpers/Helpers';
import { DataContext } from '../../../../context/DataContext';
import { isEmpty } from 'lodash';
import NoData from '../../../../components/NoData';
import SmallModal from '../../../../components/modals/SmallModal';

import { deletePermisosAsync, getPermisosAsync } from '../../../../api/Nomina';
import AddPermiso from '../permisos/AddPermiso';

const Permisos = ({ id }) => {
	const [histoyPermisos, setHistoryPermisos] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [localReload, setLocalReload] = useState(false);

	const token = getToken();
	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

	const getPermisos = async () => {
		setIsLoading(true);
		const result = await getPermisosAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setHistoryPermisos(result.data.result);
		setIsLoading(false);
	};

	useEffect(() => {
		getPermisos();
	}, [localReload]);

	const deletePermiso = async (id) => {
		Swal.fire({
			title: '¿Confirmar Eliminar?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',
			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await deletePermisosAsync(token, id);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}
					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Eliminado!', 'Constancia Eliminada.', 'success');
				})();
			}
		});
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20
					}}
				>
					<Stack
						marginTop={2}
						direction={{ xs: 'column', sm: 'row' }}
						alignItems="center"
						justifyContent={'space-between'}
					>
						<Typography color={'#00a152'} variant="h4" fontWeight={'bold'}>
							Historial de Constancias
						</Typography>

						<Button
							onClick={() => {
								setShowModal(!showModal);
							}}
							style={{
								color: '#2979ff',
								borderColor: '#2979ff'
							}}
							variant="outlined"
						>
							<FontAwesomeIcon
								style={{ marginRight: 10, fontSize: 20 }}
								icon={faCirclePlus}
							/>
							Agregar
						</Button>
					</Stack>

					<hr />

					{isEmpty(histoyPermisos) ? (
						<NoData />
					) : (
						<Stack spacing={2}>
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												#
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Motivo
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Fecha
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Horas
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Cancelado
											</TableCell>

											{isAccess(access, 'NOMINA DELETE') ? (
												<TableCell
													align="center"
													className="text-primary fw-bold"
												>
													Acciones
												</TableCell>
											) : (
												<></>
											)}
										</TableRow>
									</TableHead>

									<TableBody>
										{histoyPermisos.map((row) => {
											const { motivo, id, fecha, isCerrado, horas } = row;
											return (
												<TableRow key={id}>
													<TableCell
														align="center"
														component="th"
														scope="row"
													>
														{id}
													</TableCell>
													<TableCell align="left">{motivo}</TableCell>
													<TableCell align="center">
														{moment(fecha).format('L')}
													</TableCell>
													<TableCell align="center">{horas}</TableCell>

													<TableCell align="center">
														{isCerrado ? 'SI' : 'NO'}
													</TableCell>

													<TableCell align="center">
														{!isCerrado &&
														isAccess(access, 'NOMINA DELETE') ? (
															<IconButton
																style={{
																	color: '#f50057',
																	width: 40,
																	height: 40
																}}
																onClick={() =>
																	deletePermiso(row.id)
																}
															>
																<FontAwesomeIcon
																	icon={faTrashAlt}
																/>
															</IconButton>
														) : (
															<></>
														)}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</Stack>
					)}
				</Paper>
			</Container>

			<SmallModal
				titulo={'Agregar Constancia'}
				isVisible={showModal}
				setVisible={setShowModal}
			>
				<AddPermiso
					id={id}
					setShowModal={setShowModal}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</SmallModal>
		</div>
	);
};

export default Permisos;
